import { Button } from '@mui/material'
import Icon from '@app/stories/Icons'
import VoucherDetailsEntry from '@app/containers/VoucherDetailsEntry'

const ExpandClaimButton = ({ voucher }) => {
  return (
    <VoucherDetailsEntry voucher={voucher}>
      <Button
        size='small'
        variant='outlined'
        sx={{ textTransform: 'none', display: 'flex', alignItems: 'center' }}
      >
        <Icon name='openInFull' />
      </Button>
    </VoucherDetailsEntry>
  )
}

export default ExpandClaimButton
